import React, { Component } from "react";
import {
  Button,
  CircularProgress,
  Icon,
  IconButton,
  Link,
  Slide,
  Snackbar,
} from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import { objectAsParams } from "../../helpers/objectToQueryParams";
import Http from "../../Http";
import "./imageViewer.css";
import { AuthContext } from "../../context/authContext";
import ACCESS from "../../ACCESS";

class ImageViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filename: "",
      file: "",
      actualIndex: 1,
      rating: 0,
      modo: "info",
      guia: {
        archivo: "",
      },
      auth: '',
    };
  }

  componentDidMount() {
    this.getGuia(false, this.props.id_guia);
    const auth = localStorage.getItem('tt')
    this.setState({ actualIndex: this.props.index, auth });
    document.addEventListener("keydown", this._handleKeyChange, false);
  }

  componentDidUpdate(prevProps) {
    if (this.props.id_guia !== prevProps.id_guia) {
      this.getGuia(false, this.props.id_guia);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyChange, false);
  }

  _handleKeyChange = (event) => {
    if (event.keyCode === 39) {
      this.navigate("next");
    } else if (event.keyCode === 37) {
      this.navigate("back");
    }

    if (
      this.state.modo === "rating" &&
      [49, 50, 51, 52, 53].includes(event.keyCode)
    ) {
      const rating =
        [49, 50, 51, 52, 53].findIndex((val) => val === event.keyCode) + 1;
      this.onRatingChange(rating);
    }
  };

  async getGuia(myIndex, id_guia) {
    const { filters, index } = this.props;
    const date = new Date()
    let misfiltros = { ...filters };
    const realIndx = myIndex || index;
    if (id_guia) {
      misfiltros.id_guia = id_guia;
    }
    const Resp = await Http.get(
      `revision-evidencia/navegacion?${objectAsParams(
        misfiltros
      )}&index=${realIndx}`
    );
    if (Resp && !Resp.error) {
      Resp.data.archivo = `${Resp.data.archivo}?asd=${date.getMilliseconds()}`
      this.setState({
        guia: Resp.data,
        rating: Resp.data.calificacion > 0 ? Resp.data.calificacion : 0,
        loadimg: true,
      });
    }
  }

  navigate(action = "next") {
    const { actualIndex } = this.state;
    let index = actualIndex;
    if (action === "next") {
      index = index + 1;
    } else if (action === "back") {
      index = index - 1;
    }
    this.setState({ actualIndex: index, loadimg: false }, () => {
      this.getGuia(index);
    });
  }

  onRatingChange = async (rating) => {
    const { guia } = this.state;
    this.setState({ rating });
    await Http.post(`revision-evidencia/rating`, { guia, rating });
    this.navigate("next");
  };

  saveImage = async () => {
    const { guia, file } = this.state;
    this.setState({ ldgbtn: true });
    let form = new FormData();
    form.append("id_entrega", guia.id_guia_entrega);
    form.append("id_evidencia", this.props.row.id_evidencia);
    form.append("evidencia", file);
    if (!file) {
      this.setState({
        sbMsg: "No hay archivo",
        sbOpen: true,
        ldgbtn: false,
        filename: "",
      });
      return;
    }
    let Res = await Http.post(`revision-evidencia/reemplazar`, form);
    if (!Res.error) {
      this.setState({
        ldgbtn: false,
        sbMsg: "Imagen Guardada",
        sbOpen: true,
        modo: "info",
        filename: "",
        file: "",
      });
      await this.getGuia();
    } else {
      this.setState({
        ldgbtn: false,
        sbMsg: `Error al guardar: ${Res.errMsg}`,
        sbOpen: true,
        modo: "info",
        filename: "",
        file: "",
      });
    }
  };

  onImageChange = async (event) => {
    if (event.target.files) {
      this.setState({
        file: event.target.files[0],
        filename: event.target.value,
      });
    }
  };

  renderInfo = (guia) => (
    <>
      <div style={{ display: "flex", margin: "15px 0px" }}>
        <span style={{ fontSize: 20, fontWeight: "bold", margin: "0px 5px" }}>
          Guia:{" "}
        </span>
        <span style={{ fontSize: 20 }}>{guia.g_folio}</span>
      </div>
      <div style={{ display: "flex", margin: "15px 0px" }}>
        <span style={{ fontSize: 20, fontWeight: "bold", margin: "0px 5px" }}>
          Chofer:{" "}
        </span>
        <span style={{ fontSize: 20 }}>{guia.chofer}</span>
      </div>
      <div style={{ display: "flex", margin: "15px 0px" }}>
        <span style={{ fontSize: 20, fontWeight: "bold", margin: "0px 5px" }}>
          Fecha Entrega:{" "}
        </span>
        <span style={{ fontSize: 20 }}>{guia.fecha_entrega}</span>
      </div>
      <div style={{ display: "flex", margin: "15px 0px" }}>
        <span style={{ fontSize: 20, fontWeight: "bold", margin: "0px 5px" }}>
          Cliente:{" "}
        </span>
        <span style={{ fontSize: 20 }}>{guia.cliente}</span>
      </div>
      <div style={{ display: "flex", margin: "15px 0px" }}>
        <span style={{ fontSize: 20, fontWeight: "bold", margin: "0px 5px" }}>
          Calificacion:{" "}
        </span>
        <span style={{ fontSize: 20 }}>{guia.calificacion}</span>
      </div>
      <div
        style={{
          display: "flex",
          margin: "15px 0px",
          justifyContent: "space-around",
        }}
      >
        {this.props.scanner ? (
          <div style={{
            width: '100%'
          }} >
            <Link
              className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
              href={`twain-nodejs://received?socketid=${this.props.socketId}&id_entrega=${guia.id_guia_entrega}&auth=${this.state.auth}&typeSubmit=reemplazo&mensaje=REEMPLAZO-GUIA-${guia.g_folio}`}
              style={{
                width: '100%',
                color: 'white'
              }}
            >
              Escanear
            </Link>
          </div>
        ) : (
          <div>
            {this.context.hasAccess(ACCESS.REVISION_EVIDENCIAS.REEMPLAZAR_EVIDENCIA) &&
              <Button
                onClick={() => {
                  this.setState({ modo: "remplazo" });
                }}
                variant="contained"
                color={"primary"}
              >
                Remplazar Imagen
              </Button>
            }
            {this.context.hasAccess(ACCESS.REVISION_EVIDENCIAS.CALIFICAR_EVIDENCIA) &&
              <Button
                onClick={() => {
                  this.setState({ modo: "rating" });
                }}
                variant="contained"
                color={"primary"}
              >
                Calificar
              </Button>
            }
          </div>
        )}
      </div>
    </>
  );

  renderRating = (rating, guia) => (
    <>
      <div
        style={{
          display: "flex",
          margin: "15px 0px",
          justifyContent: "center",
        }}
      >
        <span style={{ fontSize: 20, fontWeight: "bold" }}>
          Calificar Evidencia {guia.g_folio}
        </span>
      </div>
      <div style={{ display: "flex", margin: "15px 0px" }}>
        <span style={{ fontSize: 16, fontWeight: "bold" }}>Criterios</span>
      </div>
      <span style={{ fontSize: 16 }}>-Criterio 1</span>
      <span style={{ fontSize: 16 }}>-Criterio 2</span>
      <span style={{ fontSize: 16 }}>-Criterio 3</span>
      <span style={{ fontSize: 16 }}>-Criterio 4</span>
      <span style={{ fontSize: 16 }}>-Criterio 5</span>
      <div
        style={{
          display: "flex",
          margin: "15px 0px",
          justifyContent: "center",
        }}
      >
        <Rating
          size="large"
          name="simple-controlled"
          value={rating}
          onChange={(event, newValue) => {
            this.onRatingChange(newValue);
          }}
        />
      </div>
    </>
  );

  renderRemplazo = (guia, filename, ldgbtn) => (
    <>
      <div
        style={{
          display: "flex",
          margin: "15px 0px",
          justifyContent: "center",
        }}
      >
        <span style={{ fontSize: 20, fontWeight: "bold" }}>
          Remplazar Evidencia {guia.g_folio}
        </span>
      </div>
      <div style={{ display: "flex", margin: "15px 0px" }}>
        <span style={{ fontSize: 16 }}>
          La evidencia se remplazara y ya no se podra recuperar
        </span>
        <input
          type="file"
          style={{ display: "none" }}
          id={"img_file"}
          value={filename}
          onChange={this.onImageChange}
        />
      </div>

      <label
        className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
        htmlFor="img_file"
      >
        Click Para Seleccionar Imagen
      </label>

      <div
        style={{
          display: "flex",
          margin: "15px 0px",
          justifyContent: "space-around",
        }}
      >
        <Button
          onClick={() => {
            this.setState({ modo: "info", filename: "", file: "" });
          }}
          variant="contained"
          color={"primary"}
        >
          Regresar
        </Button>
        <Button
          disabled={ldgbtn}
          onClick={() => {
            this.saveImage();
          }}
          variant="contained"
          color={"primary"}
        >
          {ldgbtn && (
            <div
              style={{ marginRight: 10, padding: 0, height: 22 }}
              hidden={!ldgbtn}
            >
              <CircularProgress color="secondary" size={20} />
            </div>
          )}
          Guardar
        </Button>
      </div>
    </>
  );

  render() {
    const {
      sbOpen = false,
      sbMsg,
      guia,
      modo,
      rating,
      filename,
      loadimg = false,
      ldgbtn = false,
    } = this.state;
    const { navegacion = true } = this.props;
    return (
      <div className="row">
        <div className="col-sm-8">
          <div className="navegacion-imagen">
            <div>
              {navegacion && (
                <IconButton
                  onClick={() => {
                    this.navigate("back");
                  }}
                  variant="contained"
                  color={"primary"}
                >
                  <Icon>navigate_before</Icon>
                </IconButton>
              )}
            </div>
            <div className="image-container">
              {loadimg ? (
                <ReactPanZoom image={guia.archivo} alt="Image alt text" />
              ) : (
                <CircularProgress size={160} />
              )}
            </div>
            <div>
              {navegacion && (
                <IconButton
                  onClick={() => {
                    this.navigate("next");
                  }}
                  variant="contained"
                  color={"primary"}
                >
                  <Icon>navigate_next</Icon>
                </IconButton>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              height: "100%",
            }}
          >
            {modo === "info" ? (
              this.renderInfo(guia)
            ) : modo === "rating" ? (
              this.renderRating(rating, guia)
            ) : modo === "remplazo" ? (
              this.renderRemplazo(guia, filename, ldgbtn)
            ) : (
              <span>a</span>
            )}
          </div>
        </div>

        <Snackbar
          resumeHideDuration={2000}
          autoHideDuration={2000}
          open={sbOpen}
          onClose={() => {
            this.setState({ sbOpen: false });
          }}
          TransitionComponent={Slide}
          message={<span>{sbMsg}</span>}
        />
      </div>
    );
  }
}
ImageViewer.contextType = AuthContext;
export default ImageViewer;